import { css } from '@/styled-system/css';

export const base = css({
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: 0,
  flexShrink: 0,
  transitionProperty: 'background-color, color, border-color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  _disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const unsaved = css({
  backgroundColor: 'hpxWhite',
  color: 'hpxTeal500',
  borderWidth: '0.533px',
  borderStyle: 'solid',
  borderColor: 'hpxTeal500',
  _hover: {
    backgroundColor: 'hpxTeal100',
  },
  _active: {
    backgroundColor: 'hpxTeal300',
  },
});

export const saved = css({
  backgroundColor: 'hpxRed100',
  color: 'hpxRed400',
  border: 'none',
  _hover: {
    backgroundColor: 'hpxRed400',
    color: 'hpxWhite',
  },
  _active: {
    backgroundColor: 'hpxRed500',
    color: 'hpxWhite',
  },
});

export const sizes = {
  sm: css({ width: '32px', height: '32px', fontSize: '14px' }),
  md: css({ width: '40px', height: '40px', fontSize: '16px' }),
  lg: css({ width: '48px', height: '48px', fontSize: '20px' }),
};

export const iconWrapper = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});
